import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";

const ItemNotification = (props) => {
  const [state, setState] = useState({
    url: "",
  });
  useEffect(() => {
    let linkUrl;
    let typeNotification = props.data.type;
    let idNotification = props.data.item_id;
    switch (typeNotification) {
      case "webinar":
        linkUrl = `/Webinar/InnerWebinar/${idNotification}`;
        break;
      case "learningContent":
        linkUrl = `/education/category/${idNotification}`;
        break;
      case "course":
        linkUrl = `/education/mycourses/${idNotification}`;
        break;
      case "lottery":
        linkUrl = `/Lottery/LotteryDetail/${idNotification}`;
        break;
      case "news":
        linkUrl = `/news/inner-page/${idNotification}`;
        break;
      default:
        linkUrl = 0;
        break;
    }
    setState({
      ...state,
      url: linkUrl,
    });
  }, []);
  return (
    <Link
      to={state.url}
      className={`item-notification ${state.url == 0 ? "disabled" : ""}`}
    >
      {props.data.read == 0 ? <b></b> : null}
      <h4>{props.data.title}</h4>
      <p>{props.data.description}</p>
      <span>{props.data.jtime}</span>
    </Link>
  );
};

export default ItemNotification;
